import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { RadioButtonChecked, Email, HideSource } from '@mui/icons-material';  // Certifique-se de importar os ícones corretamente

interface IChipStatusProps {
  status: string;
  background: string;
  color: string;
  icons: React.ReactNode;
  tooltipInfo: string;
  translationKey?: string;
}

const getTooltipDescription = (tooltipInfo: string) => {
  switch (tooltipInfo) {
    case "Convidado":
      return "Significa que o usuário recebeu um convite em seu e-mail para ativar sua conta. Usuários convidados ainda não fizeram seu cadastro, porém são contabilizados nos indicadores de participação (Aderência, Envolvimento e Fidelização) e recebem lembretes durante o periodo de medição.";
    case "Inativo":
      return "Significa que o usuário não irá participar das reflexões. Usuários inativos não são contabilizados nos indicadores de participação (Aderência, Envolvimento e Fidelização), também não podem acessar sua conta nem receber lembretes durante o periodo de medição.";
    case "Ativo":
      return "Significa que o usuário já fez seu primeiro acesso e finalizou o seu cadastro. Usuários ativos não necessariamente responderam uma reflexão ainda, porém já podem responder durante o periodo da reflexão e irão receber lembretes todo mês para participar.";
    case "Inativado pelo suporte":
      return "Significa que o usuário teve sua conta inativada pelo time de suporte técnico da Zenbox para manutenção. Usuários inativos não são contabilizados nos indicadores de participação (Aderência, Envolvimento e Fidelização), também não podem acessar sua conta nem receber lembretes durante o periodo de medição.";
    default:
      return tooltipInfo;  // Retorna o próprio texto se não encontrar uma descrição
  }
};

const ChipStatus: React.FC<IChipStatusProps> = ({ status, background, color, icons, tooltipInfo, translationKey }) => {
  const { t } = useTranslation('system');
  const translatedStatus = translationKey ? String(t(`${translationKey}.label`)) : status;
  const translatedTooltip = translationKey ? String(t(`${translationKey}.description`)) : getTooltipDescription(tooltipInfo);
  return (
    <div>
      <Tooltip title={translatedTooltip} enterTouchDelay={0} leaveTouchDelay={2000} arrow>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{
            background, color, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '.2em .8em',
            gap: '.4em', maxHeight: '36px', borderRadius: '2em'
          }}>
            {icons}
          <p style={{ margin: '0', fontSize: '12px' }}>{translatedStatus}</p>
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export default ChipStatus;
